import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { get } from 'lodash';
import Container from 'reactstrap/lib/Container';
import { getIsAppraisalLinkExcluded } from 'site-modules/shared/utils/appraisal/check-links-visible';

import { GlobalNavigationMobileWrapper } from './global-navigation-mobile-wrapper';
import { GlobalNavigationMobile } from './global-navigation-mobile';
import { GlobalNavigationDesktop } from './global-navigation-desktop';

import './global-navigation.scss';

function GlobalNavigationUI({
  isMobile,
  showSearchBar,
  pathname,
  pageName,
  selectedFacets,
  renderLogo,
  searchBarComponent,
  isLaurelBg,
}) {
  const isAppraisalLinkExcluded = getIsAppraisalLinkExcluded(pageName, selectedFacets);

  return (
    <div
      className={classnames('global-navigation w-100', {
        'is-laurel-bg': isLaurelBg,
        'is-desktop': !isMobile && isLaurelBg,
      })}
      data-tracking-parent="edm-entry-global-nav"
    >
      <Container className="px-0">
        {isMobile ? (
          <GlobalNavigationMobileWrapper>
            <GlobalNavigationMobile
              showSearchBar={showSearchBar}
              pathname={pathname}
              isAppraisalLinkExcluded={isAppraisalLinkExcluded}
              renderLogo={renderLogo}
              searchBarComponent={searchBarComponent}
            />
          </GlobalNavigationMobileWrapper>
        ) : (
          <GlobalNavigationDesktop
            showSearchBar={showSearchBar}
            pathname={pathname}
            isAppraisalLinkExcluded={isAppraisalLinkExcluded}
            renderLogo={renderLogo}
          />
        )}
      </Container>
    </div>
  );
}

GlobalNavigationUI.propTypes = {
  pathname: PropTypes.string,
  isMobile: PropTypes.bool,
  showSearchBar: PropTypes.bool,
  pageName: PropTypes.string,
  selectedFacets: PropTypes.shape({}),
  renderLogo: PropTypes.func,
  searchBarComponent: PropTypes.elementType,
  isLaurelBg: PropTypes.bool,
};

GlobalNavigationUI.defaultProps = {
  pathname: '',
  isMobile: false,
  showSearchBar: true,
  pageName: null,
  selectedFacets: {},
  renderLogo: undefined,
  searchBarComponent: undefined,
  isLaurelBg: false,
};

const mapStateToProps = state => ({
  isMobile: state.mobile,
  pathname: get(state, 'pageContext.location.pathname'),
  pageName: get(state, 'pageContext.page.name'),
  selectedFacets: get(state, 'inventory.searchResultsFilter'),
});

export const GlobalNavigation = connect(mapStateToProps)(GlobalNavigationUI);
